export enum ReportType {
    Lost = "lost",
    Found = "found"
}

export interface ColumnName {
    id: number;
    name: string;
    type: number;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
}